// extracted by mini-css-extract-plugin
module.exports =  {"additionalRibbonWrapper":"FnFuxh","additionalRibbon":"D8_vee"};